import { logError } from "@faire/web--source/common/logging";
import React, { PropsWithChildren, useContext, useEffect } from "react";
import styled, { css } from "styled-components";

import { accordionTransitionTiming } from "./Accordion";
import { AccordionContext } from "./context";

interface IProps extends PropsWithChildren {
  onTransitionEnd?: () => void;
  isDisplayFlex?: boolean;
}

/**
 * A component that animates the rotation of its children according to the state
 * of the parent accordion.
 */
export const AnimatedChevronContainer: React.FC<IProps> = ({
  children,
  isDisplayFlex,
  onTransitionEnd,
}) => {
  const context = useContext(AccordionContext);

  useEffect(() => {
    if (context === null) {
      logError("Trying to use AccordionContext outside of a provider");
    }
  }, [context]);

  return (
    <AnimationContainer
      $rotateDegrees={context ? -90 : 90}
      onTransitionEnd={onTransitionEnd}
      $isDisplayFlex={isDisplayFlex}
    >
      {children}
    </AnimationContainer>
  );
};

const AnimationContainer = styled.span<{
  $rotateDegrees: number;
  $isDisplayFlex?: boolean;
}>`
  transform: rotate(
    ${(props) => css`
      ${props.$rotateDegrees}deg
    `}
  );
  display: ${(props) => (props.$isDisplayFlex ? "flex" : "inline-block")};
  transition-property: transform;
  ${accordionTransitionTiming}
`;
